import React from "react";
import { Text } from "../design-system/components/Text";
import { Heading } from "../design-system/components/Heading";
import styled, { theme } from "../styled";
import { useGetAccountQuery } from "../graphql/hooks/useGetAccountQuery";
import { LoadingIndicator } from "../design-system/components/LoadingIndicator";

const BannerWrap = styled("div")`
  width: 25%;
  background-color: ${theme.color.red20};
  position: fixed;
  top: 0;
  right: 0;
  padding: ${theme.spacing.m};
`;

export const StaffSessionBanner = () => {
  const { data, loading } = useGetAccountQuery({});

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <BannerWrap>
        <div>
          <Heading size="l" margin="0 0 s">
            {`You are browsing ${
              data!.account!.email
            }'s account. Everything is being recorded.`}
          </Heading>
          <Text margin="0 0 s">
            Please close the window as soon as you are done.
          </Text>
        </div>
      </BannerWrap>
    </>
  );
};
